// extracted by mini-css-extract-plugin
export default {"panelHeading":"MYol"};